import React, { forwardRef, useMemo } from 'react'
import { Box, Icon, useMenuButtonBehavior, MenuStateProvider, Menu, MenuItem, MenuGroup, InputGroup } from '@maui/elements'

export const SelectMenuButton = forwardRef(({ label, placeholder, name, variant, ...props }, ref) => {
  const menuButtonProps = useMenuButtonBehavior({}, { ...props, ref })

  return (
    <Box {...menuButtonProps} width="100%">
      <InputGroup
        slotRight={<Icon name="angle-down" />}
        variant={variant}
        inputProps={{
          value: label,
          readOnly: true,
          cursor: 'pointer',
          name,
          placeholder
        }}
    />
    </Box>
  )
})

SelectMenuButton.displayName = 'SelectMenuButton'

export const DropDownSelect = forwardRef(({ value, options = [], onChange, placeholder, menuSearch, groupLabel, name, variant }, ref) => {
  const label = useMemo(() => {
    return options.find(option => option.value === value)?.label
  }, [value, options])

  const clickHandler = optionValue => () => {
    if (optionValue !== value) {
      onChange(optionValue)
    }
  }

  return (
    <MenuStateProvider initialState={{ placement: 'bottom-start' }}>
      <SelectMenuButton label={label} placeholder={placeholder} ref={ref} name={name} variant={variant} />
      <Menu width="auto" maxHeight="300px" overflowY={options?.length > 10 && 'scroll'}>
        {menuSearch}
        <MenuGroup label={groupLabel}>
          {
            !options.length &&
            <Box
              color="colorTextMain"
              textStyle="bodySmall"
              width="235px"
              p="spacePaddingLarge"
            >
              No results found
            </Box>
          }
          {options.map((option, i) => {
            const active = label === option.label
            return (
              <MenuItem
                key={i}
                onClick={clickHandler(option.value)}
                cursor={value === option.value ? 'default' : 'pointer'}
                backgroundColor={active ? 'colorFillMain' : 'transparent'}
              >
                {option.label}
                {active && <Icon name="check" />}
              </MenuItem>
            )
          }
          )}
        </MenuGroup>
      </Menu>
    </MenuStateProvider>
  )
})

DropDownSelect.displayName = 'DropDownSelect'
